export default __webpack_public_path__ + "static/media/profile.fea7b760.svg";